export default "__VITE_ASSET__D02aGFxz__"